export const _convertObject = (filters) => {
    const newFilters = Object.assign({}, filters)

    Object.keys(newFilters).forEach(key => {
        if (newFilters[key] === null || newFilters[key] === undefined || newFilters[key] === '' || (Array.isArray(newFilters[key]) && newFilters[key].length === 0)) {
            delete newFilters[key]
        }

        if (!Array.isArray(newFilters[key]) && typeof newFilters[key] === 'object') {
            const objectChild = _convertObject(newFilters[key])

            delete newFilters[key]

            if (!!objectChild && Object.keys(objectChild).length === 0) {
                delete newFilters[key]
            } else {
                return Object.assign(newFilters, {[key]: objectChild})
            }
        }
    })

    return newFilters
}

export default {
    _convertObject
}
